import { isMobile } from 'react-device-detect'

import {
   DESKTOP_MIN_WIDTH,
   TABLET_MIN_WIDTH
} from '@flowwai-frontend/shared/constants'

export const mobile = `@media (max-width: ${TABLET_MIN_WIDTH - 1}px) `

export const tablet = `@media (min-width: ${TABLET_MIN_WIDTH}px) and (max-width: ${
   DESKTOP_MIN_WIDTH - 1
}px)`

export const isMobileDevice = isMobile
